// F2-1、F3-2、F4 双图1、三图2、四图
import { FC, useMemo } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { AspectRatio, IHorizontalMutipleMedia, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'
import TagItem from '../../tag-item'

const HorizontalMutipleMedia: FC<IHorizontalMutipleMedia> = ({
  type = 'F2-1',
  title,
  titleTag,
  itemTitleTag,
  desc,
  mediaGroup = [],
  theme,
  mediaAspectRatio = AspectRatio.ThreeToTwo,
  mediaBorderRadius = 0,
  paddingTop = 'px120',
  paddingBottom = 'px120',
}) => {
  const isMobile = useMobileDetector()

  const gridClassName = useMemo(() => {
    switch (type) {
      case 'F2-1':
        return 'laptop:grid-cols-2'
      case 'F3-2':
        return 'laptop:grid-cols-3'
      default:
        return 'laptop:grid-cols-2'
    }
  }, [type])

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <TitleAndDesc title={title} desc={desc} titleTag={titleTag} />
      <div className={clsx('w-full max-w-300 mx-auto', 'px-6 laptop:px-0')}>
        <div className={clsx('grid grid-cols-1 gap-y-8 laptop:gap-x-6 laptop:gap-y-16', gridClassName)}>
          {mediaGroup.map((item) => {
            const src = isMobile ? item.mediaH5Url || item.mediaUrl || '' : item.mediaUrl || ''
            // 只让 F2-1 单项的显式关闭改变效果，空值保留历史行为。
            const hoverScaleClassName =
              type !== 'F2-1' || item.enableHoverScale !== false
                ? 'hover:scale-110 transition-all ease-in-out duration-[800ms]'
                : undefined
            // 与 PdMedia 的视频格式判定保持一致，仅让 F2-1 图片脱离固定比例布局。
            const autoHeightImage = type === 'F2-1' && !/\.(mp4|webm|avi|mov)$/i.test(src)

            return (
              <div className={clsx('w-full')} key={item.title}>
                <div
                  className={clsx('w-full overflow-hidden', !autoHeightImage && 'h-358px laptop:h-fit', 'mb-3 laptop:mb-6')}
                  style={{ aspectRatio: autoHeightImage ? undefined : mediaAspectRatio, borderRadius: `${mediaBorderRadius}px` }}
                >
                  {autoHeightImage ? (
                    src && src !== 'undefined' && (
                      // fill 定位的图片无法撑开父容器，使用图片固有比例交由浏览器计算高度。
                      // eslint-disable-next-line @next/next/no-img-element
                      <img
                        src={src}
                        alt=""
                        loading="lazy"
                        className={clsx('block w-full h-auto', hoverScaleClassName)}
                      />
                    )
                  ) : (
                    <PdMedia
                      src={src}
                      mask={false}
                      className={hoverScaleClassName}
                    />
                  )}
                </div>
                <TagItem title={item.title} desc={item.desc} titleTag={itemTitleTag} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default HorizontalMutipleMedia
